import { Children, isValidElement, useMemo } from "react";
import { useUIDSeed } from "react-uid";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

import styles from "./ButtonsCol.style";

const ButtonsColStyled = styled.div((props) => ({ ...styles(props) }));

const ButtonsCol = ({ children, className, childrenSpacing, disabled, ...rest }) => {
    const childElements = useMemo(
        () => Children.toArray(children).filter((child) => isValidElement(child)),
        [children],
    );

    const uid = useUIDSeed();

    if (!childElements.length || disabled) {
        return null;
    }

    return (
        <ButtonsColStyled childrenSpacing={childrenSpacing} className={className} {...rest}>
            {childElements.map((child, index) => {
                const { id } = child?.props;
                return (
                    <div key={uid(id || index)} className="buttonsCol_item">
                        {child}
                    </div>
                );
            })}
        </ButtonsColStyled>
    );
};

ButtonsCol.propTypes = {
    className: PropTypes.string,
    childrenSpacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
};

ButtonsCol.defaultProps = {
    className: undefined,
    childrenSpacing: 30,
    disabled: false,
};

export default ButtonsCol;
